import React from 'react';
import { useBrandingColors } from '../hooks/useBrandingColors';

/**
 * Dynamic Button Component that uses organization branding colors
 * @param {string} variant - 'primary', 'secondary', 'danger', 'success', 'outline'
 * @param {string} size - 'sm', 'md', 'lg'
 * @param {boolean} disabled
 * @param {function} onClick
 * @param {ReactNode} children
 * @param {string} className - Additional classes
 */
const BrandedButton = ({ 
  variant = 'primary', 
  size = 'md', 
  disabled = false,
  onClick,
  children,
  className = '',
  type = 'button',
  ...props 
}) => {
  const { primary, secondary } = useBrandingColors();

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };

  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: primary,
          borderColor: primary,
          color: 'white',
        };
      case 'secondary':
        return {
          backgroundColor: secondary,
          borderColor: secondary,
          color: 'white',
        };
      case 'outline':
        return {
          backgroundColor: 'transparent',
          borderColor: primary,
          color: primary,
        };
      case 'danger':
        return {
          backgroundColor: '#dc2626',
          borderColor: '#dc2626',
          color: 'white',
        };
      case 'success':
        return {
          backgroundColor: '#16a34a',
          borderColor: '#16a34a',
          color: 'white',
        };
      default:
        return {
          backgroundColor: primary,
          borderColor: primary,
          color: 'white',
        };
    }
  };

  const baseClasses = `
    font-medium rounded-lg transition-all duration-200 
    focus:outline-none focus:ring-2 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
    hover:opacity-90 active:scale-95
    border
    ${sizeClasses[size]}
    ${className}
  `;

  return (
    <button
      type={type}
      className={baseClasses}
      style={getVariantStyles()}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default BrandedButton;
